import React, { useEffect, useState } from "react";
import calendlyAssessmentStyle from "./calendlyAssessmentStyle";
import { Box, Grid, IconButton, Rating } from "@mui/material";
import { translate } from "../../services/Translations/translatorService";
import { nl2br } from "../../services/formServiceFunctions";
import { apiGet } from "../../services/Api/apiCall";
import { Activity } from "../../types/Activity";
import { CalendlyEvent } from "../../types/Calendly/CalendlyEvent";
import { UnfoldLess, UnfoldMore } from "@mui/icons-material";
import { stripHtml } from "string-strip-html";
import { getCalendlyEventReference } from "../../services/calendlyService";

export default function CalendlyAssessmentActivity({ activity }: { activity: Activity }) {
  const [calendlyEvent, setCalendlyEvent] = useState<CalendlyEvent | null>(null);
  const [isCallSummaryExpanded, setIsCallSummaryExpanded] = useState<boolean>(false);

  useEffect(() => {
    const calendlyEventReference = getCalendlyEventReference(activity.calendlyEvent);
    if (calendlyEventReference && !calendlyEvent) {
      apiGet<CalendlyEvent>(calendlyEventReference).then(setCalendlyEvent);
    }
  }, [activity, calendlyEvent]);

  if (
    !calendlyEvent ||
    !activity.done ||
    !["calendly_event", "lawyer_counseling_call"].includes(activity.type) ||
    !calendlyEvent ||
    !calendlyEvent.assessment ||
    calendlyEvent.assessment.processed === null
  ) {
    return null;
  }

  const { assessment } = calendlyEvent;

  const boolToText = (value: boolean | null) => {
    if (value === null) {
      return "-";
    }
    return value ? "Ja" : "Nein";
  };

  return (
    <Box sx={calendlyAssessmentStyle.assessmentContainer}>
      <Grid container spacing={1}>
        <Grid
          size={{
            xs: 12,
            md: 6
          }}>
          Gespräch stattgefunden: {boolToText(assessment.processed)}
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6
          }}>
          {assessment.notProcessedReason && (
            <>
              Warum nicht:{" "}
              {translate("assessment.short.notProcessedReason.values." + assessment.notProcessedReason, "-")}
            </>
          )}
        </Grid>
        {activity.type === "calendly_event" && (
          <>
            <Grid
              size={{
                xs: 12,
                md: 6
              }}>
              Weitere Mandatstätigkeiten notwendig: {boolToText(assessment.followUp)}
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6
              }}>
            </Grid>
            <Grid size={12}>
              Übernahme des Mandats: {boolToText(assessment.acceptsMandateTransferal)}
            </Grid>
            <Grid size={12}>
              Zufriedenheit Mandantschaft:
              <Rating size={"small"} value={assessment.customerSatisfaction} readOnly={true} />
            </Grid>
          </>
        )}
        {assessment.note && (
          <Grid size={12}>
            Hinweise:
            <Box
              sx={calendlyAssessmentStyle.noteContainer}
              dangerouslySetInnerHTML={{ __html: nl2br(assessment.note) }}
            />
          </Grid>
        )}

        {assessment.callSummary && stripHtml(assessment.callSummary).result && assessment.processed && (
          <Grid size={12}>
            Zusammenfassung:
            <Grid
              container
              spacing={1}
              sx={[{
                alignItems: "flex-start"
              }, calendlyAssessmentStyle.noteContainer]}>
              <Grid
                size={{
                  xs: 12,
                  md: 11
                }}>
                <Box
                  sx={{
                    pt: 1,
                    ...(isCallSummaryExpanded ? {} : calendlyAssessmentStyle.collapsedNote),
                  }}
                  dangerouslySetInnerHTML={{ __html: nl2br(assessment.callSummary) }}
                />
              </Grid>
              <Grid
                sx={{ display: "flex", justifyContent: { xs: "flex-start", md: "flex-end" } }}
                size={{
                  xs: 12,
                  md: 1
                }}>
                <IconButton
                  onClick={() => setIsCallSummaryExpanded(!isCallSummaryExpanded)}
                  aria-label={isCallSummaryExpanded ? "Weniger anzeigen" : "Mehr anzeigen"}
                  size="small"
                >
                  {isCallSummaryExpanded ? <UnfoldLess /> : <UnfoldMore />}
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
